// podcast 列表
"use client";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "next/navigation";

import { getPodcastByPage } from "@/app/actions";
import PodcastComponent from "../basic/PodcastComponent"; // podcast 元件
import LoadMore from "@/components/index/LoadMore"; // 加載更多

const PodcastList = ({ initialPodcasts, pageCnt }) => {
  const { locale } = useParams(); // 取得語系
  const { t } = useTranslation();

  const [podcasts, setPodcasts] = useState(initialPodcasts || []); // podcasts 資料
  const [pageIndex, setPageIndex] = useState(1); // 頁碼
  const [loadingMore, setLoadingMore] = useState(false);

  //   加載更多
  const onLoad = async () => {
    try {
      setLoadingMore(true);
      const { data } = await getPodcastByPage(locale, pageIndex);
      if (data) {
        setPageIndex((prev) => prev + 1);
        setPodcasts((prev) => prev.concat(data));

        setTimeout(() => {
          setLoadingMore(false);
        }, 300);
      }
    } catch (e) {
      setLoadingMore(false);
      console.error(e);
    }
  };

  return (
    <>
      <section className="space-y-[40px] mt-[40px] w-full max-w-[1146px] px-[30px] ulg:mt-[25px] usm:px-[15px] mx-auto">
        {/* 列表 */}
        {podcasts?.map((podcast, i) => (
          <PodcastComponent
            key={podcast?.id + "podcast" + i}
            t={t}
            podcast={podcast}
          />
        ))}
      </section>

      {/* 加載更多 */}
      {pageCnt > pageIndex && (
        <LoadMore onLoad={onLoad} loadingMore={loadingMore} />
      )}
    </>
  );
};

export default PodcastList;
